// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"4841":"5e0e7ca6","8058":"78eb88a9"}[chunkId] + ".chunk.css";
};